import styled from 'styled-components';
import moment from 'moment';

import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';
import { useLanguage } from '../../Context/LanguageContext';

import AttendanceRankingList from '../../Model/Individual/StatisticsModel/AttendanceRankingList';

import IntroMarkdown from './IntroMarkdown';

export default function AttendanceRankingListRenderer(props) {
  const { data } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  const { intro, ranking, startDate, month, periodLabel } = data;

  // 산정기간 표시 텍스트 계산 — 신 경로는 month·startDate 대신 periodLabel('YYYY-MM' 또는 'start~end')을 보낸다 //
  function calcDateText() {
    const isMonthLabel = /^\d{4}-\d{2}$/.test(periodLabel || '');

    if (!month && !startDate && periodLabel && !isMonthLabel) return periodLabel;

    const monthKey = month || (isMonthLabel ? periodLabel : null);
    const target = monthKey ? moment(monthKey + '-01T00:00:00') : (startDate ? moment(startDate) : moment());

    return target.format(t('statistics.dateFormatMonth'));
  }

  return (
    <TopLevelWrapper>
      <IntroMarkdown text={intro} color={theme.text} />
      <ListContainer $bg={theme.subBackground}>
        <ListInnerBox>
          <AttendanceRankingList
            data={ranking || []}
            selectedPartnerGym={undefined}
            calcDateText={calcDateText} />
        </ListInnerBox>
      </ListContainer>
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  gap: 12px;
`;

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  max-width: 100%;

  padding: 16px;

  border-radius: 10px;
  background-color: ${props => props.$bg};

  overflow-x: auto;

  box-sizing: border-box;
`;

// 통계 순위표는 칸 너비가 고정이라 답 칸보다 넓으면 본문 줄만 잘린다 — 표를 제 너비로 두고 머리글·본문을 함께 가로 스크롤 //
const ListInnerBox = styled.div`
  width: max-content;
  min-width: 100%;
`;
